<template>
	<transition-group name="list" :class="{
		'window-stack-view': true,
		active: popups.length > 0
	}">
		<component class="popup" v-for="(p, i) in _popups" :key="i" :is="p.component" v-bind="p" @pop="$emit('pop')" :style="{
			top: 	p.top,
			right: 	p.right,
			left: 	p.left
		}" @click.native.stop="" />
	</transition-group>
</template>

<script>
	export default {
		watch: {
			popups: {
				deep: false,
				handler(n) {
					console.log(n);

					if (n.length == 0) {
						document.removeEventListener('click', this.documentClick);
						this.listening = false;
					} else if (!this.listening && n.length == 1) {
						var self = this;
						self.listening = true;
						
						setTimeout(() => {
							document.addEventListener('click', self.documentClick);
						}, 20);
					}
				}
			}
		},
		data() {
			return {
				listening: false
			};
		},
		props: {
			popups: {
				type: Array,
				required: true
			}
		},
		computed: {
			_popups() {
				var r = [];

				for (var i = 0; i < this.popups.length; ++i) {
					var p 	= {...this.popups[i], ...{}};
					//var pb	= p.target.getBoundingClientRect();
					var b 	= p.target.getBoundingClientRect();

					console.log('bound', b);
					console.log('screen', screen);
					console.log('setup', p);

					if (p.direction == 'down') {
						if (p.align == 'ccw') {
							p.top	= `${b.bottom + p.margin.top}px`;
							p.right	= 'auto';
							p.left 	= `${b.left + p.margin.left}px`;
						}

						if (p.align == 'cw') {
							p.top	= `${b.bottom + p.margin.top}px`;
							p.right	= `${window.innerWidth - b.right + p.margin.right}px`;
							p.left 	= 'auto';
						}
					}

					r.push(p);
				}

				console.log(r);

				return r;
			}
		},
		methods: {
			documentClick() {
				console.log('doc click!! dismiss all');

				this.$emit('clear');
			}
		}
	}
</script>

<style lang="scss" scoped>
	.window-stack-view {
		position: fixed;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		z-index: 10000;
		background-color: #00000000;
		pointer-events: none;

		grid-template-columns: 	1fr;
		grid-template-rows: 	1fr;
		justify-items: center;
		align-items: center;

		transition: 100ms background-color ease-in-out;

		& > .popup {
			pointer-events: all;
			transition: 150ms opacity ease-in-out, 150ms transform ease-in-out;
			position: absolute;
		}
	}

	.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
		transform: scale(1.6) ! important; 
		opacity: 0 ! important;
	}
</style>